import { makeAutoObservable } from 'mobx'
import { type IDropdownItem } from 'shared/ui'

export class UsersMultiDropdownStore {
  isAutoTenMembers = false

  constructor(
    public initUsersIds?: number[],
    private readonly _getMaxMembers?: () => number | null,
    isAutoTenMembers?: boolean
  ) {
    this.isAutoTenMembers = isAutoTenMembers ?? false
    makeAutoObservable(this)
  }

  get maxMembers(): number | null {
    return this._getMaxMembers?.() ?? null
  }

  private get _membersCount(): number {
    return this.initUsersIds?.length ?? this.selectedMembers.length
  }

  get isLimitReached(): boolean {
    return this.maxMembers !== null && this._membersCount >= this.maxMembers
  }

  get params() {
    if (this.isAutoTenMembers) return []
    if (this.initUsersIds) return this.initUsersIds
    return this.selectedMembersIds
  }

  private _selectedMembers: IDropdownItem[] = []
  get selectedMembers() {
    return this._selectedMembers
  }

  setAutoTenMembers = () => {
    this.isAutoTenMembers = true
    this._selectedMembers = []
    this.initUsersIds = undefined
  }

  clearAutoTenMembers = () => {
    this.isAutoTenMembers = false
  }

  setSelectedMembers = (value: IDropdownItem) => {
    if (this.isLimitReached) return
    if (this.initUsersIds) {
      this.initUsersIds = undefined
    }
    this.isAutoTenMembers = false
    this._selectedMembers = [...this._selectedMembers, value]
  }
  setInitMembers = (items: IDropdownItem[]) => {
    this._selectedMembers = items
    this.initUsersIds = undefined
  }

  get selectedMembersIds() {
    return this.selectedMembers.map((elem) => Number(elem.id))
  }

  deleteSelectedMembers = (value: IDropdownItem) => {
    this._selectedMembers = this._selectedMembers.filter((item) => item.id !== value.id)
  }

  private _error = ''
  get error() {
    return this._error
  }
  setError = (error: string) => {
    this._error = error
  }

  validate = () => {
    let valid = true
    this.setError('')
    const count = this._membersCount
    if (!count && !this.isAutoTenMembers) {
      this.setError('Please select at least one user')
      valid = false
    }
    if (this.maxMembers !== null && count > this.maxMembers) {
      this.setError(`Maximum ${this.maxMembers} members allowed`)
      valid = false
    }
    return valid
  }
}
